<!-- Panel (always in DOM when open, hidden when minimized to preserve ng-content) -->
@if (isOpen()) {
  <aside class="side-panel"
         [class.side-panel--hidden]="isCollapsed()"
         [style.width]="panelWidth()"
         [style.top]="headerOffset()"
         role="complementary"
         aria-label="Painel lateral">

    <!-- Header -->
    <div class="side-panel__header">
      @if (icon()) {
        <div class="side-panel__header-icon">
          <span class="material-symbols-outlined">{{ icon() }}</span>
        </div>
      }
      <div class="side-panel__header-text">
        <h3 class="side-panel__title">{{ title() }}</h3>
        @if (subtitle()) {
          <span class="side-panel__subtitle">{{ subtitle() }}</span>
        }
      </div>
      <div class="side-panel__header-actions">
        @if (showMinimize()) {
          <button type="button"
                  class="side-panel__header-btn"
                  (click)="minimize()"
                  title="Minimizar painel"
                  aria-label="Minimizar painel">
            <span class="material-symbols-outlined">remove</span>
          </button>
        }
        @if (showClose()) {
          <button type="button"
                  class="side-panel__header-btn"
                  (click)="requestClose()"
                  title="Fechar painel"
                  aria-label="Fechar painel">
            <span class="material-symbols-outlined">close</span>
          </button>
        }
      </div>
    </div>

    <!-- Body (scrollable) -->
    <div class="side-panel__body">
      <ng-content></ng-content>
    </div>

  </aside>
}

<!-- Minimized floating tab -->
@if (isCollapsed()) {
  <button type="button"
          class="side-panel-tab"
          [style.top]="headerOffset()"
          (click)="restore()"
          title="Restaurar painel"
          aria-label="Restaurar painel — {{ title() }}">
    @if (icon()) {
      <span class="material-symbols-outlined side-panel-tab__icon">{{ icon() }}</span>
    }
    <span class="side-panel-tab__label">{{ title() }}</span>
    @if (hasUnsavedChanges()) {
      <span class="side-panel-tab__dot" title="Alterações não guardadas"></span>
    }
  </button>
}

<!-- Unsaved changes confirmation dialog -->
@if (showConfirmDialog()) {
  <div class="side-panel-confirm-overlay" role="dialog" aria-modal="true" aria-labelledby="side-panel-confirm-title">
    <div class="side-panel-confirm-dialog">
      <h4 class="side-panel-confirm-dialog__title" id="side-panel-confirm-title">Alterações não guardadas</h4>
      <p class="side-panel-confirm-dialog__body">
        Tem alterações que não foram guardadas. Tem a certeza que pretende fechar o painel?
      </p>
      <div class="side-panel-confirm-dialog__actions">
        <button type="button" class="side-panel-confirm-dialog__btn side-panel-confirm-dialog__btn--cancel" (click)="cancelClose()">
          Cancelar
        </button>
        <button type="button" class="side-panel-confirm-dialog__btn side-panel-confirm-dialog__btn--discard" (click)="confirmClose()">
          Descartar e fechar
        </button>
      </div>
    </div>
  </div>
}
